module.exports = "/static/assets/f40501ed87782097b1a4eec8747eb84a.png";